import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const API_BASE_URL = "https://bluewaterdubai.websiteseoonline.com";
const DEVELOPER_CITY = "Dubai";

function buildApiUrl(pathname) {
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || API_BASE_URL).replace(/\/$/, "");
  return `${baseUrl}${pathname}`;
}

function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function developerSlug(developer) {
  const id = String(developer.id || "");
  const urlParts = String(developer.url || "")
    .split("/")
    .map((part) => part.trim())
    .filter(Boolean);
  const lastPart = urlParts[urlParts.length - 1];
  const slugFromUrl = lastPart === id ? urlParts[urlParts.length - 2] : urlParts.find((part) => !["developer", "developers", "develope"].includes(part));

  return slugify(slugFromUrl || developer.name) || "developer";
}

function developerUrl(developer) {
  const id = developer.id ? encodeURIComponent(developer.id) : "";
  return id ? "/developers/" + developerSlug(developer) + "/" + id : "/developers";
}

function imageWithVariant(image, variant, fallback) {
  return image ? `${image}/${variant}` : fallback;
}

function DeveloperLogos() {
  const [developers, setDevelopers] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    async function loadDevelopers() {
      try {
        const response = await fetch(buildApiUrl("/api/developerlisthome.ashx"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ city: DEVELOPER_CITY }),
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Unable to load developers");
        }

        const payload = await response.json();
        setDevelopers(payload.result === 1 && Array.isArray(payload.data) ? payload.data : []);
      } catch (err) {
        if (err.name !== "AbortError") {
          setDevelopers([]);
        }
      }
    }

    loadDevelopers();

    return () => controller.abort();
  }, []);

  const logoTrack = useMemo(() => {
    if (!developers.length) {
      return [];
    }

    return [...developers, ...developers];
  }, [developers]);

  return (
    <div className="developer-logo-loop">
      <h2>Trusted Partner of the Most Prominent Developers</h2>
      <div className="logo-slider">
        <div className="logo-track">
          {logoTrack.map((developer, index) => (
            <Link className="logo-box" to={developerUrl(developer)} key={(developer.id || developer.name) + "-" + index}>
              <img src={imageWithVariant(developer.ImagePath, "w=130,sharpen=1", "assets/img/brand/1.jpg")} alt={developer.name || "Developer logo"} />
            </Link>
          ))}
        </div>
      </div>
      <style>{`
        .developer-logo-loop { background: #fff; overflow: hidden; }
        .developer-logo-loop h2 { text-align: center; text-transform: capitalize; font-size: 40px; font-weight: 100; color: #111; margin-bottom: 35px; }
        .logo-slider { width: 100%; overflow: hidden; }
        .logo-track { display: flex; align-items: center; gap: 20px; width: max-content; animation: scrollLogo 35s linear infinite; }
        .logo-box { width: 160px; height: 90px; border: 1px solid #eee; border-radius: 14px; padding: 18px; display: flex; align-items: center; justify-content: center; background: #fff; flex-shrink: 0; }
        .logo-box img { max-width: 100%; max-height: 85px; object-fit: contain; display: block; }
        @keyframes scrollLogo { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        @media (max-width: 768px) {
          .developer-logo-loop { padding: 40px 0; }
          .developer-logo-loop h2 { font-size: 24px; padding: 0 15px; }
          .logo-track { gap: 25px; animation-duration: 18s; }
          .logo-box { width: 120px; height: 70px; padding: 12px; }
          .logo-box img { max-height: 42px; }
        }
      `}</style>
    </div>
  );
}

export default DeveloperLogos;
